import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CSSProperties } from 'react';
// Fix the import path to be within the src directory
import landingImage from "../../assets/images/background/bg-5.jpg";

const Index11 = () => {
  const navigate = useNavigate();

  // Base button style with mobile considerations
  const buttonStyle: CSSProperties = {
    padding: '10px 20px',
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    color: 'white',
    textDecoration: 'none',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    fontSize: '12px',
    fontWeight: '600',
    borderRadius: '0',
    transition: 'all 0.3s ease',
    margin: '5px',
    display: 'inline-block',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    cursor: 'pointer',
    maxWidth: '100%',
    boxSizing: 'border-box',
  };

  // Profile button style
  const profileButtonStyle: CSSProperties = {
    ...buttonStyle,
    position: 'absolute' as const,
    top: '20px',
    left: '20px',
    zIndex: 10,
    padding: '10px 20px',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    borderColor: 'rgba(255, 255, 255, 0.3)',
  };

  const handleProfileClick = () => {
    console.log('Profile button clicked');
    navigate('/profile');
  };

  return (
    <React.Fragment>
      <button 
        onClick={handleProfileClick}
        style={{
          ...profileButtonStyle,
        }}
      >
        PROFILE
      </button>
      
      <section
        style={{
          backgroundImage: `url(${landingImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          minHeight: '100vh',
          color: 'white',
          textAlign: 'center',
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
        }}
      >
        {/* Overlay for text */}
        <div style={{ 
          position: 'absolute', 
          top: '0', 
          left: '0', 
          width: '100%', 
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.4)', 
          padding: '0 20px',
        }}>
          {/* Training Plan Link REMOVED */}
          
          {/* Main Title */}
          <h1 style={{
            fontFamily: "'Bebas Neue', 'Oswald', sans-serif",
            fontWeight: '700',
            fontSize: '120px',
            fontStyle: 'italic',
            lineHeight: '1',
            textTransform: 'uppercase',
            letterSpacing: '20px',
            color: '#ffffff',
            marginBottom: '40px',
            textShadow: '2px 2px 8px rgba(0, 0, 0, 0.3)',
            maxWidth: '100%',
            wordBreak: 'break-word',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            WHAT
            <span style={{ display: 'block' }}>WORKOUT</span>
          </h1>
          
          {/* Descriptive text */}
          <p style={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: '400',
            fontSize: '16px',
            maxWidth: '800px',
            width: '100%',
            color: '#ffffff',
            marginBottom: '60px',
            lineHeight: '1.8',
            letterSpacing: '1px',
            padding: '0 15px',
          }}>
            Generate personalized workouts tailored to your discipline and fitness levels
          </p>
          
          {/* Discipline Buttons - Fixed layout */}
          <div 
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '10px',
              margin: '0 auto',
              maxWidth: '900px', // Increased from 800px to allow more space
              width: '100%',
              padding: '0 15px',
            }}
          >
            <Link to="/strength-training" style={buttonStyle}>STRENGTH</Link>
            <Link to="/crossfit" style={buttonStyle}>CROSSFIT</Link>
            <Link to="/powerlifting" style={{...buttonStyle, minWidth: '120px'}}>POWERLIFTING</Link>
            <Link to="/bodybuilding" style={{...buttonStyle, minWidth: '120px'}}>BODYBUILDING</Link>
            <Link to="/hyrox" style={buttonStyle}>HYROX</Link>
            <Link to="/yoga" style={buttonStyle}>YOGA</Link>
            <Link to="/home-workouts" style={buttonStyle}>HOME</Link>
          </div>
        </div>
      </section>

      {/* Global mobile styles */}
      <style>{`
        @media (max-width: 600px) {
          body {
            font-size: 14px;
          }

          section h1 {
            font-size: 60px !important;
            letter-spacing: 10px !important;
            margin-bottom: 20px !important;
          }

          section p {
            font-size: 14px !important;
            margin-bottom: 30px !important;
          }

          section div[style*="display: flex"] {
            gap: 8px !important;
          }

          button[style*="Profile"] {
            top: 10px !important;
            left: 10px !important;
            padding: 8px 15px !important;
            font-size: 10px !important;
          }
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default Index11;